import React, {Component} from 'react';
import bus from './bus';
import Ajax from './ajax';

class BindPhone extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.sendSMS = this.sendSMS.bind(this);
    }

    submit(event) {
        event.preventDefault();
        if (this.code.value.length != 4) {
            alert('请输入完整的验证码');
        } else {
            Ajax.post('bind', {code: this.code.value}, function (response) {
                if (response.result) {
                    bus.emit('result', response);
                }
            });
        }
    }

    sendSMS() {
        if (this.phone.value.length > 0) {
            Ajax.post('sms', {phone: this.phone.value}, function (callback) {
                if (callback.result) {
                    alert('验证码发送成功');
                }
            });
        } else {
            alert('请输入手机号');
        }
    }

    render() {
        return (
            <form onSubmit={this.submit}>
                <div className="weui-cells weui-cells_form">
                    <div className="weui-cell weui-cell_vcode">
                        <div className="weui-cell__hd">
                            <label className="weui-label">手机号</label>
                        </div>
                        <div className="weui-cell__bd">
                            <input ref={(phone) => this.phone = phone} className="weui-input" type="tel" placeholder="请输入手机号"/>
                        </div>
                        <div className="weui-cell__ft">
                            <button className="weui-vcode-btn" type="button" onClick={this.sendSMS}>获取验证码</button>
                        </div>
                    </div>
                    <div className="weui-cell">
                        <div className="weui-cell__hd"><label className="weui-label">验证码</label></div>
                        <div className="weui-cell__bd">
                            <input ref={(code) => this.code = code} name="code" className="weui-input" type="number" pattern="[0-9]{4}" placeholder="请输入验证码"/>
                        </div>
                    </div>
                    <div className="weui-btn-area">
                        <input className="weui-btn weui-btn_primary" type="submit" value="提交"/>
                    </div>
                </div>
            </form>
        );
    }
}

export default BindPhone;



// WEBPACK FOOTER //
// ./src/bind-phone.js